import qs from 'qs';
import { network } from 'services/network';

export const deleteReport = ({ reportId }) => {
    const querystring = qs.stringify({ reportId }, { addQueryPrefix: true, skipNulls: true });
    const url = `api/bo/reporting/deleteReport${querystring}`;

    return network.post(url).then((response) => {
        return response.data;
    });
};
